var map = {
	"./allied_tank.webp": "2e6d",
	"./clone_troopers.webp": "9d30",
	"./fastrope.webp": "df11",
	"./fireteam_sunrise.webp": "3ebc",
	"./vietnam_sniper.webp": "403f",
	"./weapons_team.webp": "50d5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9568";